import { cn, Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@shared/components/shadcn';

type ScratchcardPrizeTableRow = {
  tier: number;
  prize: string;
  amount: string;
};

type ScratchcardPrizeTableProps = {
  rows: ScratchcardPrizeTableRow[];
  title: string;
  tierLabel: string;
  prizeLabel: string;
  amountLabel: string;
};

const HEAD_CELL_CLASS = 'w-1/3 px-4 py-2 paragraph-explanatory-strong text-foreground';
const BODY_CELL_CLASS = 'px-4 py-3 paragraph-explanatory text-foreground';

/**
 * Scratchcard prize table component.
 * @param rows - The rows of the table.
 * @param title - The title of the table.
 * @param tierLabel - The label for the tier column.
 * @param prizeLabel - The label for the prize column.
 * @param amountLabel - The label for the amount column.
 */
function ScratchcardPrizeTable({ rows, title, tierLabel, prizeLabel, amountLabel }: ScratchcardPrizeTableProps) {
  return (
    <section className="flex w-full flex-col gap-4" data-testid="scratchcard-prize-table">
      <p className="paragraph-strong text-foreground">{title}</p>
      <div className="overflow-hidden rounded-lg bg-container">
        <Table className="w-full border-0" aria-label={title}>
          <TableHeader className="[&_tr]:border-0">
            <TableRow className="border-0 hover:bg-transparent">
              <TableHead className={HEAD_CELL_CLASS}>{tierLabel}</TableHead>
              <TableHead className={cn(HEAD_CELL_CLASS, 'text-center')}>{prizeLabel}</TableHead>
              <TableHead className={cn(HEAD_CELL_CLASS, 'text-right')}>{amountLabel}</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {rows.map(row => (
              <TableRow key={row.tier} className="border-0 hover:bg-transparent" data-testid={`scratchcard-prize-table-row-${row.tier}`}>
                <TableCell className={BODY_CELL_CLASS}>{row.tier}</TableCell>
                <TableCell className={cn(BODY_CELL_CLASS, 'text-center')}>{row.prize}</TableCell>
                <TableCell className={cn(BODY_CELL_CLASS, 'text-right')}>{row.amount}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </section>
  );
}

export { ScratchcardPrizeTable, type ScratchcardPrizeTableProps, type ScratchcardPrizeTableRow };
